import { useCallback, useLayoutEffect, useRef } from 'react';
export function useEvent(handler) {
  var handlerRef = useRef(handler);
  useLayoutEffect(function () {
    handlerRef.current = handler;
  });
  return useCallback(function () {
    var fn = handlerRef.current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return fn === null || fn === void 0 ? void 0 : fn.apply(void 0, args);
  }, []);
}